import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Button from 'antd/es/button';
import { Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons';
import { ReactComponent as QuickRepliesPlus } from '../../../assets/icons/plus/quickRepliesPlus.svg';
import EntityListItem from './EntityListItem';
import { Operation } from '../index';
import styles from '../EntityManager.module.scss';
const { Text } = Typography;
const EntityList = observer(function (props) {
    const Teaser = props.teaser;
    const isInactive = (entity) => (props.disabled ? props.disabled(entity) : false) ||
        (props.readOnly ? props.readOnly(entity) : false);
    let entities = [...props.entities].sort((a, b) => isInactive(a) > isInactive(b) ? 1 : -1);
    if (props.sorter) {
        entities = entities.sort(props.sorter);
    }
    return (React.createElement("div", { className: styles.listRoot },
        props.loading ? (React.createElement("div", { className: styles.listPreloaderContainer },
            React.createElement(LoadingOutlined, { className: styles.listPreloader }))) : (React.createElement("ul", { className: styles.listContents }, entities.map((entity) => {
            if (props.renderListItem) {
                return props.renderListItem(entity, props);
            }
            return (React.createElement(EntityListItem, { key: entity[props.entityIdKey], entity: entity, entityIdKey: props.entityIdKey, disabled: props.disabled, readOnly: props.readOnly, onEdit: props.onEdit, onDelete: props.onDelete, customListActions: props.customListActions, isHighlighted: props.currentOperation === Operation.EDIT &&
                    props.selectedEntityId !== null &&
                    props.selectedEntityId !== undefined &&
                    entity[props.entityIdKey] === props.selectedEntityId },
                React.createElement(Teaser, Object.assign({ entity: entity }, props.additionalProps))));
        }))),
        typeof props.onCreate === 'function' && (React.createElement("div", { className: styles.listActions },
            React.createElement(Button, { className: classNames(styles.actionButton, 'big'), onClick: () => props.onCreate && props.onCreate() },
                React.createElement(Icon, { component: QuickRepliesPlus }),
                React.createElement(Text, { strong: true }, props.createTitle))))));
});
export default EntityList;
